import React from 'react';
import Accordion from './Accordion'; // Import your Accordion component
import './accordian.css'; // Import your CSS file

const AccordianPage = () => {
  // Define your accordion items here
  const items = [
    {
      title: 'What services do you offer?',
      content: 'We provide a full range of interior design services including space planning, concept design, 3D visualization, material selection, furniture design, lighting planning, and turnkey project execution.',
    },
    {
      title: 'What types of projects do you work on?',
      content: 'We work on residential projects (apartments, villas, homes) as well as commercial spaces such as offices, retail stores, and hospitality environments.',
    },
    {
      title: 'How does the design process work?',
      content: 'Our process typically includes:\n1. Initial consultation\n2. Understanding your requirements and budget\n3. Concept design & mood boards\n4. 3D design and revisions\n5. Execution & site supervision\n6. Final handover',
    },
    {
      title: 'Do you offer customized designs?',
      content: 'Yes, every project is fully customized based on your lifestyle, preferences, and functional needs. We do not use one-size-fits-all designs.',
    },
    {
      title: 'How much does interior design cost?',
      content: 'Costs vary depending on the size of the project, materials used, and level of customization. We offer flexible packages to suit different budgets.',
    },
    {
      title: 'Do you provide a free consultation?',
      content: 'We offer an initial consultation to understand your requirements and discuss how we can help.',
    },
    {
      title: 'How long does a project take to complete?',
      content: 'Timelines depend on the scope of work. Typically:\n● Design phase: 1–3 weeks\n● Execution phase: 4–12 weeks',
    },
    {
      title: 'Can I see a 3D design before execution?',
      content: 'Yes, we provide detailed 3D visualizations so you can clearly see how your space will look before work begins.',
    },
    {
      title: 'Do you handle project execution as well?',
      content: 'Yes, we offer turnkey solutions, meaning we handle everything from design to final installation.',
    },
    {
      title: 'Can you work within my budget?',
      content: 'Absolutely. We tailor designs and material choices to match your budget without compromising on quality.',
    },
    {
      title: 'Do you source materials and furniture?',
      content: 'Yes, we assist with sourcing materials, furnishings, décor, and accessories from trusted vendors.',
    },
    {
      title: 'Will I be involved in the design process?',
      content: 'Yes, your input is essential. We collaborate closely with you at every stage to ensure the design reflects your vision.',
    },
    {
      title: 'Do you offer renovation services?',
      content: 'Yes, we specialize in both new interiors and renovation projects, including complete home makeovers.',
    },
    {
      title: 'What makes your design approach unique?',
      content: 'We focus on blending aesthetics with functionality, ensuring every design is practical, timeless, and personalized.',
    },
    {
      title: 'Do you provide warranties or guarantees?',
      content: 'Yes, we provide warranties on workmanship and materials (terms depend on the project and vendors).',
    },
    {
      title: 'How do I get started?',
      content: 'You can contact us via phone, email, or our website contact form to schedule your consultation.',
    },
    {
      title: 'Do you work on small projects?',
      content: 'Yes, we handle projects of all sizes—from single-room designs to complete homes.',
    },
    {
      title: 'What if I don’t like the design?',
      content: 'We include revision stages in our process to refine the design until you are satisfied.',
    },
    {
      title: 'Are your designs Vastu-compliant (or Feng Shui)?',
      content: 'Yes, we can incorporate Vastu or other design principles upon request.',
    },
    {
      title: 'Do you offer eco-friendly design options?',
      content: 'Yes, we can suggest sustainable materials and energy-efficient solutions for environmentally conscious designs.',
    },
    {
      title: 'Do you provide post-completion support?',
      content: 'Yes, we offer support after project completion for any adjustments or concerns.',
    },
    {
      title: 'Can you design remotely or online?',
      content: 'Yes, we offer online design consultations and services for clients in different locations.',
    },
  ];

  return (
    <div className='accordian faq-layout'>
      <div className="accordian-col">
        <p className='qa'>QUESTIONS & ANSWERS</p>
        <h2 className='header2'>Let us help you find clarity</h2>
        <p className='qa-exp'>
          We’re here to answer your queries and guide you through every step of your journey with us. Explore our frequently asked questions below.
          {/* <br /><br />
          Experience the ultimate getaway at our luxurious resort,
          where every detail is designed to offer. */}
        </p>
      </div>

      <div className="accordian-col">
        {/* Place the Accordion component here */}
        <Accordion items={items} />
      </div>
    </div>
  );
};

export default AccordianPage;
